// Autogenerated file, DO NOT MODIFY or it will be overwritten;
import type { SVGProps } from 'react';

import { forwardRef } from '@chakra-ui/react';

import { Icon, type IconProps } from '../Icon';

const Svg = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 20 20"
    {...props}
  >
    <g clipPath="url(#a)">
      <path
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={1.75}
        d="M9.99935 12.2727L11.5145 13.7878L14.9236 10.3787M13.5963 6.21208C12.9235 3.5981 10.5506 1.66663 7.72662 1.66663C4.37944 1.66663 1.66602 4.38005 1.66602 7.72723C1.66602 10.5512 3.59749 12.9241 6.21147 13.5969M12.2721 18.3333C8.9249 18.3333 6.21147 15.6199 6.21147 12.2727C6.21147 8.92551 8.9249 6.21208 12.2721 6.21208C15.6193 6.21208 18.3327 8.92551 18.3327 12.2727C18.3327 15.6199 15.6193 18.3333 12.2721 18.3333Z"
      />
    </g>
    <defs>
      <clipPath id="a">
        <path fill="#fff" d="M0 0H20V20H0z" />
      </clipPath>
    </defs>
  </svg>
);
const IconDoubleCircleCheck = forwardRef(
  (props: Omit<IconProps, 'icon'>, ref) => {
    return <Icon ref={ref} icon={Svg} {...props} />;
  }
);
export default IconDoubleCircleCheck;
